module.exports = __webpack_public_path__ + "img/account-dark.33c90164.svg";